import styles from "./input-element-top-section.module.less";

type TInputElementTopSectionProps = {
  label?: string;
  legend?: string | React.ReactNode;
  helperText?: string;
  errorText?: string;
  htmlFor?: string;
};

export const InputElementTopSection = ({
  label,
  legend,
  helperText,
  errorText,
  htmlFor = undefined,
}: TInputElementTopSectionProps) => {
  return (
    <div className={styles.wrapper}>
      {label && (
        <label htmlFor={htmlFor} className={styles.label}>
          <span className="body-s bold mb-0">{label}</span>
        </label>
      )}
      {legend && (
        <legend className={styles.label}>
          <span className="body-s bold mb-0">{legend}</span>
        </legend>
      )}
      {helperText && <span className={[styles.helperText, "body-s mb-0"].join(" ")}>{helperText}</span>}
      {errorText && (
        <div className={`${styles.errorText}`}>
          <span className={[styles.errorIcon, "ui-icon-error"].join(" ")} />
          <span>{errorText}</span>
        </div>
      )}
    </div>
  );
};

export default InputElementTopSection;
